import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-arrow-right",
  "use": "icon-cl-arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.293 3.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L8.586 8 5.293 4.707a1 1 0 0 1 0-1.414Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol